import { Button, Dialog, Slide, Snackbar, Alert } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import success from "../../assets/success.svg";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function SuccessModal({
  dialogSuccess,
  dispatch,
  platform,
  description,
  orders
}) {

  const classes = styles();
  const isApp = platform === "app";
  const paymentStatusCode = orders?.paymentStatusCode === 'PaymentPending'; // chưa thanh toán
  const [open, setOpen] = React.useState(false);

  const handleCopy = (code) => {
    // Copy vào clipboard
    navigator.clipboard
      .writeText(code)
      .then(() =>
        setOpen(true)
      )
      .catch((err) => console.log("Copy lỗi:", err));
  };

  return (
    <Dialog open={!!dialogSuccess?.open} TransitionComponent={Transition}>
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpen(false)} severity="success" sx={{ width: "100%" }}>
          Sao chép thành công!
        </Alert>
      </Snackbar>
      <div className={classes.container}>
        <img src={success} width={45} />
        {isApp ? (
          <>
            <div className={classes.title}>
              {paymentStatusCode ? "Đã thêm vào giỏ hàng" : "Thanh toán thành công"}
            </div>
            {
              paymentStatusCode ?
                <div className={classes.content}>
                  Đơn hàng <span className="bold">Cứu hộ xe máy 247
                  </span> đã
                  được thêm vào giỏ hàng <span className="bold">thành công.</span>
                </div> :
                <div className={classes.content}>
                  Đơn hàng <span className="bold">Cứu hộ xe máy 247
                  </span> đã
                  được thanh toán <span className="bold">thành công.</span>
                </div>
            }

            <div className={classes.wrapperBtn}>
              {
                paymentStatusCode ?
                  <>
                    <Button
                      className="btn back"
                      onClick={() => window.location.reload()}
                    >
                      Tiếp tục mua sắm
                    </Button>
                    <Button className="btn next" onClick={() => dispatch("payOrder")}>
                      Thanh toán ngay
                    </Button>
                  </> :
                  <Button
                    className="btn back"
                    style={{ width: '100%' }}
                    onClick={() => window.location.reload()}
                  >
                    Tiếp tục mua sắm
                  </Button>
              }

            </div>
          </>
        ) : (
          <>
            <div className={classes.title}>{paymentStatusCode ? "Tạo đơn hàng thành công" : "Thanh toán thành công"}</div>
            {
              paymentStatusCode ?
                <div className={classes.content}>
                  {description ? (
                    description
                  ) : (
                    <div>
                      Để thực hiện thanh toán cho đơn hàng này, hệ thống sẽ chuyển
                      bạn tới cổng thanh toán VNPT. Global Care sẽ không lưu trữ
                      thông tin của bạn dưới bất kỳ hình thức nào.
                    </div>
                  )}
                </div> :
                <div style={{ fontSize: 12, lineHeight: 1.5 }}>
                  Mã đơn hàng <br />
                  <span onClick={() => handleCopy(orders?.transCode)} style={{ fontSize: 18 }}><b>{orders?.transCode}</b></span>
                  <ContentCopyIcon
                    style={{ color: "#F58220", fontSize: 16, marginLeft: 5 }}   // Đổi màu
                    onClick={() => handleCopy(orders?.transCode)}
                  />
                  <br />
                  Bạn đã thanh toán thành công đơn hàng
                </div>
            }
            {
              paymentStatusCode ?
                <Button
                  className="btn next w-80"
                  onClick={() => dispatch("payOrder")}
                >
                  Thanh toán ngay
                </Button> :
                <Button
                  className="btn next w-80"
                  style={{ color: '#009B4B', background: '#fff', border: '1px solid #009B4B', width: '100%' }}
                  onClick={() => window.location.reload()}
                >
                  Tiếp tục mua sắm
                </Button>
            }
          </>
        )}
      </div>
    </Dialog>
  );
}

const styles = makeStyles(() => ({
  container: {
    textAlign: "center",
    padding: "16px",

    "& .btn": {
      width: "48%",
      borderRadius: "8px",
      fontSize: 15,
      fontWeight: 500,
      alignItems: "center",
      textAlign: "center",
      textTransform: "none",
    },

    "& .back": {
      border: "1px solid #009B4B",
      color: "#009B4B",
    },

    "& .next": {
      backgroundColor: "#009B4B",
      color: "white",
      "&:hover": {
        backgroundColor: "#009B4B",
      },
    },

    "& .w-80": { width: "80%", marginTop: 15 },
  },
  title: { fontSize: 20, margin: "10px 0", color: "#383D3B", fontWeight: 600 },
  content: {
    fontSize: 15,
    lineHeight: 1.3,
    "& .bold": { fontWeight: 600 },
  },
  wrapperBtn: {
    marginTop: 15,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
}));
